<template>
  <div class="top-bar">
    <div class="left-section">
      <q-btn class="back-btn" flat round dense icon="arrow_back" size="md" @click="handleBackNavigation">
        <q-tooltip>{{ backTooltipText }}</q-tooltip>
      </q-btn>
      <h1 class="title-text">Image to Video Generator</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoGeneratorTopBar',
  props: {
    image: {
      type: Object,
      required: false,
      default: null
    },
    hasImage: {
      type: Boolean,
      required: false,
      default: false
    },
    showHistoryPanel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      historyPanel: false
    };
  },
  computed: {
    backTooltipText() {
      return this.hasImage ? 'Back' : 'Back to previous';
    }
  },
  watch: {
    showHistoryPanel: {
      immediate: true,
      handler(val) {
        this.historyPanel = val;
      }
    }
  },
  methods: {
    handleBackNavigation() {
      // Simply go back to previous route - much simpler!
      this.$router.go(-1);

      // Also emit the close event for the dialog
      this.$emit('update:isOpen', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  display: flex;
  align-items: center;
  padding: 0 24px;
  height: 75px;
  background-color: var(--secondary-bg-color);
  box-shadow: 0 2px 12px var(--card-shadow-color);
  position: sticky;
  top: 0;
  z-index: 10;
  width: 100%;
  overflow: hidden;

  .left-section {
    display: flex;
    align-items: center;
  }

  .title-text {
    @include inter-font($size: 18px, $bolded: true, $color: var(--main-text-color), $weight: 600);
    margin: 0 0 0 12px;
  }

  .back-btn {
    width: 40px;
    height: 40px;
    color: var(--main-text-color);
    transition: all 0.2s ease;

    &:hover {
      background: rgba(0, 0, 0, 0.05);
      color: var(--main-btn-color);
    }

    &:active {
      transform: scale(0.95);
    }
  }
}
</style>
